import Utils from "../utils/Utils.js";

const PreferenceMixin = {
  methods: {
    checkIfReady() {
      var ready = false;

      ready =
        1 <= this.voted.length && this.voted.length <= this.preference.MaxVotes;
      this.atLeastOne = 1 <= this.voted.length;
      this.tooMany = this.voted.length >= this.preference.MaxVotes;
      this.ready = ready;
      return;
    },
    vote() {
      if (this.voted.length < this.preference.MaxVotes) {
        if (this.voted.length < this.numCandidates) {
          this.confirmVoteDialog = true;
        } else {
          this.confirmVote();
        }
      } else {
        this.confirmVote();
      }
    },
    candidateSelected(evt) {
      if (evt.value === true && this.voted.includes(evt) === false)
        this.voted.push(evt);
      if (evt.value === false)
        this.voted = this.voted.filter(
          item =>
            item.candidate.CandidateIdentifier.Id !==
            evt.candidate.CandidateIdentifier.Id
        );
      this.checkIfReady();
    },
    confirmVote() {
      this.$emit("preferenceSelected", this.voted);
    },
    labelContesto(contesto, from, to) {
      if (contesto == null || contesto == "") {
        return ".";
      }
      var res = contesto.split("-");
      if (res.length > 1) {
        //res = "da " + res[0] + " a " + res[1] + ". ";
        res = from + " " + res[0] + " " + to + " " + res[1] + ". ";
      } else {
        res =
          this.$i18n.locale == "de"
            ? ", " + res[0] + ". "
            : "in " + res[0] + ". ";
      }
      return res;
    }
  },
  computed: {
    sexVoted() {
      if (this.electionType === "NORMAL") return 0;
      let n = null;
      if (this.electionType === "AIDED_EQUAL_OPPORTUNITIES") n = 2;
      if (this.electionType === "AIDED_THREE_EQUAL_OPPORTUNITIES") n = 3;
      let sexVoted = this.voted.map(vote => {
        return vote.gender;
      });
      return new Utils().checkEqualOpp2(n, sexVoted, this.preference.MaxVotes);
    }
  }
};

export default PreferenceMixin;
